export const searchWords = ({ dispatch }, e) => {
	dispatch('SEARCH_WORDS', e.target.value);
};
export const searchWordsLink = ({ dispatch }, value) => {
	dispatch('SEARCH_WORDS', value);
};
export const searchConditions = ({ dispatch }, value) => {
	dispatch('SEARCH_CONDITIONS', value);
};
export const radio = ({ dispatch }, e) => {
	const value = parseInt(e.target.value, 10);
	dispatch('RADIO', e.target.name, value);
};
export const checkbox = ({ dispatch }, e) => {
	const value = e.target.checked ? 1 : 0;
	dispatch('CHECKBOX', e.target.name, value);
	// dispatch('CREATE_QUERY', e.target.name + ':' + value);
};
export const areacode = ({ dispatch }, value) => {
	dispatch('AREA_CODE', value);
};
export const SCStr = ({ dispatch }, value) => {
	dispatch('SC_STR', value);
};

// イメージ検索 ボタン
export const imageSearch = ({ dispatch }, e) => {
	// 値をリセット
	dispatch('RESET_CHECKED_IMAGE');

	const value = parseInt(e.currentTarget.value, 10);
	dispatch('IMAGE_SEARCH', e.currentTarget.name, value);
};
// イメージ検索 チェックボックス
export const checkboxImageSearch = ({ dispatch }, e) => {
	const value = e.target.checked ? 1 : 0;
	dispatch('IMAGE_SEARCH', e.target.name, value);
};

export const reset = ({ dispatch }) => {
	dispatch('RESET');
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js